
@if (workMode == 'tabitOrder') {
	@if (orderService.$storage.isInCheckout) {
		<div class="_link" matRipple (click)="onAction('checkout')">
			<mat-icon svgIcon="shopping-cart"></mat-icon>
			<div>{{'TD.my-order' | translate}}</div>
		</div>
	}
	<div class="_link text-accent _btn" matRipple (click)="onAction('restartOrder');">
		<mat-icon svgIcon="reload"></mat-icon>
		<div>{{'TO.restart-order' | translate}}</div>
	</div>
	@if (orderService.$storage.canTakeaway ) {
		<div class="_link" matRipple (click)="onAction('changeToPickup')">
			<mat-icon svgIcon="package"></mat-icon>
			<div>{{'TO.change_to_takeaway' | translate}}</div>
		</div>
	}
	<hr />
}

@if (!appService.user) {
	<!--START ANONIMUS IN USER-->
	@if (appService.enableLogin) {
		<div class="_banner">
			<div class="_title">{{'_LOYALTY.banner_save_time' | translate}}</div>
			<!--<div class="_body">
				<span>{{'_LOYALTY.banner_side_start' | translate}}</span>
				<img src="/assets/images/logo-light.svg">
				<span>{{'_LOYALTY.banner_side_end' | translate}}</span>
			</div>-->
		</div>

		<!--<div class="_link text-accent _btn" matRipple (click)="closeSidenav(); dialogsService.login(null, 'sideNav')">-->
		<div class="_link text-accent _btn" matRipple (click)="onAction('signin')">
			<mat-icon svgIcon="user_circle"></mat-icon>
			<div>{{'sign_in_nav' | translate}}</div>
		</div>

		<hr />
	}

	@if (appService.urlParams.orderValidated) {
		<div class="_link" matRipple (click)="closeSidenav(); passOrder()">
			<mat-icon svgIcon="paper_plane"></mat-icon>
			<div>{{'PASS_ORDER' | translate}}</div>
		</div>
		<hr />
	}

	<div class="_link" matRipple (click)="closeSidenav(); appService.showContractDialog('contract')">
		<mat-icon svgIcon="shield_check"></mat-icon>
		<div>{{'CONTRACT_C' | translate}}</div>
	</div>

	<div class="_link" matRipple (click)="closeSidenav(); appService.showContractDialog('privacy')">
		<mat-icon svgIcon="shield_keyhole"></mat-icon>
		<div>{{'CONTRACT_D' | translate}}</div>
	</div>
	<!--END ANONIMUS IN USER-->
} @else {
	<!--START SIGNED IN USER-->
	<div class="_banner">
		<div class="_title">{{'_LOYALTY.hi_name' | translate: {name:appService.user?.name} }}</div>
		<div class="_body">
			<span>{{'_LOYALTY.banner_side_ligin_start' | translate}}</span>
			<img src="/assets/images/logo-light.svg">
		</div>
	</div>

	<div class="_link" matRipple (click)="closeSidenav(); dialogsService.showAccount()">
		<mat-icon class="text-accent" svgIcon="user_circle"></mat-icon>
		<div>{{'my_account' | translate}}</div>
	</div>
	<div class="_link" matRipple  (click)="closeSidenav(); dialogsService.showHistory()">
		<mat-icon class="text-accent" svgIcon="history"></mat-icon>
		<div>{{'my_history' | translate}}</div>
	</div>

	@if (appService.regionArgs?.enableWallet) {
		<div class="_link" (click)="onAction('wallet')">
			<mat-icon class="text-accent" svgIcon="logo"></mat-icon>
			<div>{{'my_wallet' | translate}}</div>
		</div>
	}
	<hr />

	@if (appService.urlParams.orderValidated) {
		<div class="_link" matRipple (click)="closeSidenav(); passOrder()">
			<mat-icon class="text-accent" svgIcon="paper_plane"></mat-icon>
			<div>{{'PASS_ORDER' | translate}}</div>
		</div>
	}

	@if (appService.region == 'IL') {
<!--		<div class="_link" matRipple (click)="closeSidenav(); accessService.toggleActive()">
			<mat-icon class="text-accent" svgIcon="accessibility"></mat-icon>
			<div>{{'ACCESS.ACCESSIBILITY' | translate}}</div>
		</div>
		<hr />-->
	}

	<div class="_link" matRipple (click)="closeSidenav(); appService.showContractDialog('contract')">
		<mat-icon class="text-accent" svgIcon="shield_check"></mat-icon>
		<div>{{'CONTRACT_C' | translate}}</div>
	</div>

	<div class="_link" matRipple (click)="closeSidenav(); appService.showContractDialog('privacy')">
		<mat-icon class="text-accent" svgIcon="shield_keyhole"></mat-icon>
		<div>{{'CONTRACT_D' | translate}}</div>
	</div>

	<hr />

	<div class="_link" matRipple (click)="onAction('signout')">
		<mat-icon class="text-accent" svgIcon="signout"></mat-icon>
		<div>{{'logout' | translate}}</div>
	</div>

	<!--END SIGNED IN USER-->
}

@if (appService.appConfig.isDev) {
	<hr/>
	<div class="_link" matRipple (click)="reload()">
		<mat-icon>reload</mat-icon>
		<div>{{ 'RELOAD' | translate }}</div>
	</div>
}


<div class="text-muted text-center p-3 d-flex align-items-center justify-content-center" style="margin-top: 30px; gap:5px">
	<span>{{appService.version}}</span>
	<span>(001)</span>
</div>






